var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgModeBusWaltti = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.6 24H2.4A2.4 2.4 0 0 1 0 21.6V2.4A2.4 2.4 0 0 1 2.4 0h19.2A2.4 2.4 0 0 1 24 2.4v19.2a2.4 2.4 0 0 1-2.4 2.4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18.075 2.4H5.925c-.67 0-1.214.544-1.214 1.215v14.58c0 .67.543 1.214 1.215 1.214h12.149c.67 0 1.215-.543 1.215-1.215V3.615c0-.671-.544-1.215-1.215-1.215M9.3 3.486h5.4V4.4H9.3zM6.856 17.232a.93.93 0 1 1 0-1.86.93.93 0 0 1 0 1.86m10.288 0a.93.93 0 1 1 0-1.86.93.93 0 0 1 0 1.86m.93-4.854c0 .22-.146.412-.359.469a23 23 0 0 1-5.715.755 23 23 0 0 1-5.715-.755.485.485 0 0 1-.36-.47V5.795c0-.269.218-.486.486-.486h11.177c.268 0 .486.217.486.486z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7.786 19.388h-1.86V21.6h1.86zM18.075 19.388h-1.86V21.6h1.86z"
})));
export { SvgModeBusWaltti as ReactComponent };